<template>
  <a-card :bordered='false' class='main_box' size='small'>
    <div class='table-operator'>
      <a-button icon='plus' type='primary' @click='handleAdd("新增映射")'>新增</a-button>
      <div style='width: 600px;float: right;text-align: right'>
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-form-item label="被映射表单">
            <a-input placeholder="请输入被映射表单名称" v-model="queryParam.title"></a-input>
          </a-form-item>
          <a-form-item>
            <a-button type='primary' @click='searchQuery'>查询</a-button>
            <a-button  @click='searchReset'>重置</a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div>
      <a-table :columns='columns'
               :dataSource='dataSource'
               :loading='loading'
               :pagination='ipagination'
               rowKey='id'
               size='small'
               @change='handleTableChange'>
        <span slot='action' slot-scope='text, record'>
          <a-button size='small' type='primary' @click='handleStop(record)'>停用</a-button>
          <a-divider type='vertical' />
          <a-popconfirm title='确定删除吗?' @confirm='() => handleDelete(record.id)'>
            <a-button size='small' type='danger'>删除</a-button>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <mapping-model ref="modalForm" @ok="modalFormOk"></mapping-model>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import MappingModel from '@views/project/setting/mapping/MappingModel'

export default {
  name: 'Mapping',
  components: { MappingModel},
  mixins: [JeecgListMixin],
  data() {
    return {
      url: {
        list: '?'
      },
      disableMixinCreated: true
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '序号',
          align: 'center',
          width: 80,
          customRender: (text, record, index) => index + 1
        },
        {
          title: '被映射表单',
          dataIndex: '被映射表单',
          ellipsis: true
        },
        {
          title: '被映射指标',
          dataIndex: '被映射指标',
          ellipsis: true
        },
        {
          title: '映射数据源',
          dataIndex: '映射数据源',
          ellipsis: true
        },
        {
          title: '映射描述',
          dataIndex: '映射描述',
          ellipsis: true
        },
        {
          title: '操作',
          width: 200,
          scopedSlots: { customRender: 'action' },
        }
      ]
    }
  },
  created() {
    this.ipagination.pageSize = 20
    for (let i = 0; i < 11; i++) {
      this.dataSource.push({ id: i,'被映射指标': '被映射指标' + i})
    }

    // this.loadData(1)
  },

  methods: {

    /**
     * 停用
     * @param id
     */
    handleStop({ id }) {

    }
  }

}
</script>

<style scoped lang="less">
@import '~@/assets/less/common.less';
</style>
